<template lang="pug">
  .russia
    .title-img-wrap
      .img-bg
      img(
      src="@/assets/images/countries/russia-min.png"
      )
      span {{ gettext('Россия') }}
    p.type-thin {{ gettext('Общие данные о стране') }}
    .content.one-grid
      div
        p {{ gettext('Проживают в стране, занимающей первое место в мире по территории, очень на природные ресурсы. Страна объединяет на своих землях много разных национальностей, которые имеют общие черты характера – консерватизм, выносливость, терпеливость, оптимизм, коллективность, общительность. Русские люди не боятся работы, они имеют хорошую смекалку, которая помогает им находить разные варианты для решения задач.') }}
        p {{ gettext('Несмотря на столь большой экономический потенциал страны, многие россияне не брезгуют возможностью заработка за границей, который зачастую оценивается на порядок выше, нежели заработок по той же профессии в своей стране. Стоит заметить, что в России дают хорошее базовое и высшее образование, теоретические и практические навыки. Конечно, есть отличия между европейской системой образования и русской, но русские специалисты имеют хорошую репутацию. Многие медработники подтверждают свои дипломы в других странах и приступают к работе как специалисты.') }}
        p {{ gettext('Россияне работают во многих странах Европы, Азии и Америки: Германии, Австрии, Голландии, Франции, Италии, Скандинавии, Прибалтике, Польше, Чехии, Словакии, Венгрии, США, Китае, Южной Корее, Японии и других. Учитывая разные данные, численность русской диаспоры по всем странам мира насчитывает около 20 млн человек.') }}
        p {{ gettext('Русские люди находят себя во многих сферах деятельности: сельском и лесном хозяйстве, строительстве и технических специальностях, производстве (на фабриках и заводах), в сфере сервиса (в гостиницах и отелях, ресторанах, кафе), транспорта и связи (водители грузовиков, автобусов), социальных и персональных услуг (помощники по дому, сиделки, няни, гувернантки, повара), здравоохранения (врачи и медсестры), торговли (продавцы и консультанты), образования (воспитатели, учителя), тренера, инструкторы и простые разнорабочие в различных секторах.') }}
        p {{ gettext('Русская рабочая сила вносит свой вклад в иностранную экономику на разных уровнях, от предоставления недорогой рабочей силы в секторах малого и среднего бизнеса до развития науки и инновационных проектов с помощью высококвалифицированных трудовых кадров.') }}
        p {{ gettext('Многие россияне со школьной скамьи изучали английский или немецкий язык, правда, стоит отметить, что уровень владения у молодого поколения заметно выше нежели и более зрелого.') }}
        p {{ gettext('Работодатели характеризуют русских работников как исполнительных, легко-обучаемых и ответственных.') }}

        router-link(:to="`/${getLanguage}/countries`")
          button.main-btn.bg-transparent.google
            | {{ gettext('See other countries') }}
</template>
<script>

import { gettext } from '@/services/TranslateHandler'
import { mapGetters } from 'vuex'
import mixin from '@/mixins'

export default {
  props: ['country'],
  mixins: [
    mixin
  ],
  metaInfo () {
    return this.getMetaInfoMixin({defaultMetaInfo: this.defaultMetaInfo, sharedImg: document.location.origin + 'webapp/images/countries/russia-min.png'})
  },
  name: 'Russia',
  methods: {
    gettext: gettext
  },
  computed: {
    ...mapGetters([
      'getLanguage'
    ]),
    defaultMetaInfo () {
      return {
        title: 'Russia | ' + gettext('Countries'),
        titleTemplate: null,
        link: [
          {rel: 'canonical', href: document.location.origin + document.location.pathname}
        ]
      }
    }
  }
}
</script>

<style lang='scss' src='../country/styles.scss'></style>



// WEBPACK FOOTER //
// src/pages/countries/russia/index.vue